module.exports = {
      id: "ic-donchian-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-donchian-usage",
      toString: function () {
        return this.url;
      }
    }